import script from "./MyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MyModal.vue?vue&type=script&setup=true&lang=js"

import "./MyModal.vue?vue&type=style&index=0&id=0a73c094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a73c094"]])

export default __exports__